import React, { SFC } from "react";
import "./style.scss";

type PropsType = {};

const ButtonRow = (props): SFC => {
    return <div className="ButtonRow">{props.children}</div>;
};

export default ButtonRow;
